export function updateTheme() {
  const sysIsDark = window.matchMedia('(prefers-color-scheme:dark)');
  const w = window;
  const dark = (w.esaUiSettings.theme == 'dark'
    || (w.esaUiSettings.theme == 'system' && sysIsDark.matches));
  const cl = document.body.classList;
  cl.remove(dark ? 'light-theme' : 'dark-theme');
  cl.add(dark ? 'dark-theme' : 'light-theme');
  for (const c of Array.from(cl)) {
    if (c.substr(0, 6) == 'pillar') {
      cl.remove(c);
      break;
    }
  }
  cl.add('pillar-' + w.esaUiSettings.pillar);
}
export function setupThemeListener() {
  const dark = window.matchMedia('(prefers-color-scheme:dark)');
  updateTheme();
  dark.addListener(updateTheme);
}
